import * as React from 'react';
const classNames = require('classnames');

interface Props {
	wrapperClassName?: string;
	sectionClassName?: string;
	children?: {};
	fluid?: boolean;
}

const Section: React.StatelessComponent<Props> = ({
	fluid = false,
	wrapperClassName,
	sectionClassName,
	children
}) => {
	return (
		<div className={classNames(fluid ? 'container-fluid' : 'container', wrapperClassName)}>
			<section className={classNames('section', sectionClassName)}>{children}</section>
		</div>
	);
};

export default Section;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/sections/Section.tsx